import Link from "next/link";

import BreadCrumb from "shared/BreadCrumb";
import { Button } from "ui/Button";
import { StrapiImage, StrapiImageData } from "ui/StrapiImage";
import { useI18n } from "utils/with-i18n.utils";

export type ReferralPicture = {
  desktop: Partial<StrapiImageData> | undefined;
  mobile: Partial<StrapiImageData> | undefined;
};

export const HeroSection = (referralPicture: ReferralPicture) => {
  const i18n = useI18n();

  return (
    <section>
      <div className="flex flex-col grow lg:flex-row">
        <div className="flex flex-col border-t border-black lg:hidden">
          <BreadCrumb
            parts={[
              { label: i18n.t("breadcrumb.home"), to: "/" },
              {
                label: i18n.t("breadcrumb.referral"),
                to: "/parrainage",
              },
            ]}
            className="lg:hidden"
          />

          <Link href="/parrainage">
            <a className="relative w-full h-full border-y border-black">
              <StrapiImage
                isFuture={true}
                image={{
                  ...referralPicture.mobile,
                  alternativeText: "hero mobile picture",
                }}
                sizes="(max-width: 1024px) 100vw, 0vw"
                size="xxlarge"
                priority
                objectFit="contain"
              />
            </a>
          </Link>
        </div>

        <article className="flex basis-[48%] flex-col items-center lg:py-0 lg:px-24 lg:max-w-screen-md lg:border-r lg:border-b lg:border-black">
          <BreadCrumb
            parts={[
              { label: i18n.t("breadcrumb.home"), to: "/" },
              {
                label: i18n.t("breadcrumb.referral"),
                to: "/parrainage",
              },
            ]}
            className="hidden p-3 m-0 w-full h-full border-y border-black lg:flex lg:p-0 lg:border-0"
          />

          <div className="flex flex-col gap-y-4 justify-center items-center px-4 mb-12 max-w-3xl lg:items-start lg:px-0 lg:mb-24">
            <div className="mt-10 text-3xl font-medium text-center lg:text-5xl lg:text-left">
              {i18n.t("referral.heroSection.title")}
            </div>

            <h1 className="text-center lg:text-lg lg:text-left">
              {i18n.t("referral.heroSection.subTitle", {}, { html: true })}
            </h1>

            <Link href="/espace-membre">
              <a>
                <Button className="mt-4 text-lg lg:text-xl">
                  <span>{i18n.t("referral.heroSection.cta")}</span>
                </Button>
              </a>
            </Link>
          </div>
        </article>

        <div className="hidden relative grow bg-slate-700 lg:flex">
          <Link href="/smartphone">
            <a className="relative w-full h-full">
              <StrapiImage
                image={{
                  ...referralPicture.desktop,
                  alternativeText: "hero desktop picture",
                }}
                size="xxlarge"
                objectFit="cover"
                sizes="(min-width: 600px) 50vw, 0vw"
                priority
              />
            </a>
          </Link>
        </div>
      </div>
    </section>
  );
};
